import { memo } from 'react'
import ExploreCategoryChip from 'tripPlanner/components/Chat/ExploreCategoryChip'
import ExploreChipCarousel from 'tripPlanner/components/Chat/ExploreChipCarousel'
import type { ChatExploreCategory, ChatExploreCategoryKey } from 'tripPlanner/config/exploreCategories'
import { thingsToDoCategories } from './thingsToDoCategories'

interface Props {
  selectedCategoryKey: ChatExploreCategoryKey
  onSelectCategory: (category: ChatExploreCategory) => void
  isFetching: boolean
  label: string
}

function ThingsToDoCategoryChips({
  selectedCategoryKey,
  onSelectCategory,
  isFetching,
  label,
}: Props) {
  return (
    <ExploreChipCarousel label={label}>
      {thingsToDoCategories.map((category) => (
        <ExploreCategoryChip
          key={category.key}
          category={category}
          isSelected={category.key === selectedCategoryKey}
          isDisabled={isFetching}
          onSelect={onSelectCategory}
        />
      ))}
    </ExploreChipCarousel>
  )
}

export default memo(ThingsToDoCategoryChips)
